<script setup>
import UserAvatar from "@/Components/users/UserAvatar.vue";

defineProps({
    user: {
        type: Object,
        required: true,
    },
    size: {
        type: String,
        default: ''
    },
    noHref: Boolean
});
</script>

<template>
    <UserAvatar :id="noHref || !user?.permissions?.view ? '' : user.id"
                :size="size"
                :avatar="user.avatar || ''"
                :name="user.name || ''"
                :badge="user.has_signature ? 'has-signature' : ''"/>
</template>
